(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define("social-groups-platform-app", ["lodash"], factory);
	else if(typeof exports === 'object')
		exports["social-groups-platform-app"] = factory(require("lodash"));
	else
		root["social-groups-platform-app"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 